<template>
  <div class="col-md-3 col-sm-3 col-6" v-if="coach">
    <div class="single-coach-box">
      <div class="content">
        <a :href="(coach.hyperlink == undefined ? '/coach-details/' : coach.hyperlink) + coach.post_slug">
          <div class="content-overlay"></div>
          <img class="content-image" :src="coach.image_url">
          <div class="content-details fadeIn-bottom">
            <p class="content-title">Know more</p>
            <img src="/img/coaches/knowmore-icon.png" alt="">
          </div>
        </a>
      </div>
      <div class="coach-name">
        <p class="hf_heading06">{{ coach.post_title }}</p>
        <p class="hf_bodytext02" v-if="coach.hyperlink != undefined">{{ coach.location }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    coach: { type:Object, default: () => ({})},
  }, 
  mounted(){ 
    // console.log("hi");
    // console.log(this.team);
  }
}

</script>